import gsap from 'gsap'

//UTILITY FUNCTIONS
function $ (className){
  return document.querySelector(`.${className}`)
}
function $$ (id){
  return document.querySelector(`#${id}`)
}

// blend two hex colors together by an amount
// https://stackoverflow.com/questions/6367010/average-2-hex-colors-together-in-javascript/56348573#56348573
function blendColors(colorA, colorB, amount) {
  const [rA, gA, bA] = colorA.match(/\w\w/g).map((c) => parseInt(c, 16));
  const [rB, gB, bB] = colorB.match(/\w\w/g).map((c) => parseInt(c, 16));
  const r = Math.round(rA + (rB - rA) * amount).toString(16).padStart(2, '0');
  const g = Math.round(gA + (gB - gA) * amount).toString(16).padStart(2, '0');
  const b = Math.round(bA + (bB - bA) * amount).toString(16).padStart(2, '0');
  return '#' + r + g + b;
}

// SELECTIONS
const resourceTank = $('resource-tank')
const agitator = $('agitator')
const agitatorFan = $('agitator-fan')

const intankFlowLines = $('intank-flow-lines')

//Pipes
const outerPipe = $('outer-pipe')
const innerPipe = $('inner-pipe')


//Valves
const gateValve = $('gate-valve')
const nrcValve = $('NRC-valve-BL')

//Flows
const flow = $('flow')


const mixerCover1 = $('mixer-cover-1')
const mixerBg1 = $('mixer-bg-1')
const mixerCover2 = $('mixer-cover-2')
const mixerBg2 = $('mixer-bg-2')

const mixingFlowLinesS1Array = [$('b-1-s1'),$('b-2-s1'),$('b-3-s1'),$('middle-s1'),$('t-1-s1'),$('t-2-s1'),$('t-3-s1')]
const mixingFlowLinesS2Array = [$('b-1-s2'),$('b-2-s2'),$('b-3-s2'),$('middle-s2'),$('t-1-s2'),$('t-2-s2'),$('t-3-s2')]

//Fan
const pump = $('pump')

//TEXTS
const emulsionHybridSystemsT = $('emulsion-hybrid-systems')
const pumpText = $('pump-text')
const mixriteStaticMixerT = $('mixrite-static-mixer')
const recirculationLineT = $('recirculation-line')
const mechanicalAgitatorT = $('mixrite-agitator')

//Tank
const linearGradient = $$('paint0_linear')

const topColor = linearGradient.firstChild.getAttributeNode('stop-color').nodeValue
const bottomColor = linearGradient.lastChild.getAttributeNode('stop-color').nodeValue
const blendedColor = blendColors(topColor, bottomColor, 0.5)



// ANIMATION UTILITY FUNCTIONS
function drawSVG(path, drawingDuration = 2, positionParameter = '', ease = 'power4.out') {
    const l = path.getTotalLength()
    const tl = new gsap.timeline()
    tl.set(path, {strokeDasharray:l})
    .fromTo(path, {
        strokeDashoffset:l,
        opacity: 0
    }, {
        strokeDashoffset:0,
        duration: drawingDuration,
        opacity: 1,
        ease: ease
    }, positionParameter);
    return tl
}

function curvedDrawingSVGAndStrokeAnimation(path, duration = 10, strokeDasharray= '4 4', reverse = false){
  const tl = new gsap.timeline()
  drawSVG(path, reverse)

  if(!reverse){
    tl.to(path, {
      strokeDasharray: strokeDasharray,
      strokeOpacity: 0.5,
      ease: 'power4.out',
      duration: 0.2
    }, 'dashes+=1')
  
    .fromTo(path, {
      strokeDashoffset: path.getTotalLength() , 
    }, {
      strokeDashoffset: 0,
      ease: 'linear',
      repeat: -1,
      duration: duration
    }, '>')  

  } else {
    tl.to(path, {
      strokeDasharray: strokeDasharray,
      strokeOpacity: 0.5,
      ease: 'power4.out',
      duration: 0.2
    }, 'dashes+=1')
  
    .fromTo(path, {
      strokeDashoffset: 0,
    }, {
      strokeDashoffset: path.getTotalLength() , 
      ease: 'linear',
      repeat: -1,
      duration: duration
    }, '>')  
  }
  
  return tl
}
// https://greensock.com/forums/topic/21618-remove-an-element-at-end-of-tween/
function removeElement(element) {
    if (typeof(element) === "string") {
        element = document.querySelector(element);
    }
    return function() {
        element.parentNode.removeChild(element);
    };
}

function alphaAnimation(element, drawingDuration = 2, ease = 'sine', positionParameter = ''){
  const tl = new gsap.timeline()
  tl
    .fromTo(element, {
      opacity: 0
    }, {
      duration: drawingDuration,
      opacity: 1,
      ease: ease
    }, positionParameter);
  return tl
}

//ANIMATIONS
function setThings(){
  const tl = new gsap.timeline()
  tl.set([resourceTank,
    agitator,
    intankFlowLines,
    outerPipe,
    innerPipe,
    gateValve,
    nrcValve,
    flow,
    mixerCover1,
    mixerBg1,
    mixerCover2,
    mixerBg2,
    ...mixingFlowLinesS1Array,
    ...mixingFlowLinesS2Array,
    pump,
    emulsionHybridSystemsT,
    pumpText,
    mixriteStaticMixerT,
    recirculationLineT,
    // mechanicalAgitatorT
], {opacity: 0})
  return tl
}
function entry() {
  const tl = new gsap.timeline
  tl.fromTo([resourceTank, agitator], {
      opacity: 0,
      y: -5,
      ease: 'sine',
      duration: 0.5,
    }, {
      y: 0,
      stagger:  0.2,
      opacity: 1
  }).from(mechanicalAgitatorT, {
      opacity: 0,
      x: 5,
      ease:  'sine',
      duration: 1,
  }, '-=0.5')
  .fromTo([mixerBg1, mixerCover1,], {
      y: 5, opacity: 0
    }, {
        opacity: 1, y:0,
    }, "-=1")
  .fromTo([mixerBg2, mixerCover2], {
      y: 5, opacity: 0
    }, {
        opacity: 1, y:0,
    }, "-=0.7")
  .fromTo(mixriteStaticMixerT, {y: -5, opacity: 0}, {ease: 'sine', opacity: 1, y: 0}, '-=0.5')
  return tl
}
function pipeCreations(){
  const tl = new gsap.timeline()
  drawSVG(outerPipe, 2, '')
  drawSVG(innerPipe, 2, '')
  tl.to(recirculationLineT, {opacity: 1, duration: 2, ease: 'sine'})
  return tl
}
function pipeAppearance(){
  const tl = new gsap.timeline()
  alphaAnimation(outerPipe, 2, '')
  alphaAnimation(innerPipe, 2, '')
  alphaAnimation(pump)
  alphaAnimation(gateValve, 2, 'sine')
  alphaAnimation(nrcValve)
  tl.fromTo(recirculationLineT, {opacity: 0, duration: 1, ease: 'sine'}, {y: 0, opacity: 1})
  return tl
}
function flowStart(){
    const tl = new gsap.timeline()
    tl
    // .fromTo([pump, pumpText], {y: -5, opacity: 0}, {y: 0, opacity: 1, duration: 2, ease: 'sine', stagger: 0.5})
    // .to([gateValve, nrcValve], {y: 5, opacity: 1, stagger: 0.5, duration: 1, ease: 'expo.in'}, "-=0.5")
    .fromTo(pump, {
        rotate: '0deg',
        transformOrigin: 'center center',
    },{
        repeat: -1,
        duration: 2,
        rotate: '360deg',
        ease: 'linear'
    }, "+=1")
    .fromTo(flow, {
        strokeDasharray: "0 0",
        opacity: 0,
        duration: 0.5,
        attr: {d:  "M57 174"}
      }, {
        opacity: 1,
        attr: {d:  "M57 174v146"}
      }, '-=1')
      .to(flow, {
        attr: {d: "M57 174v146h337"},
        duration: 5
      }, '>')
      .to(flow, {
        attr: {d: "M57 174v146h337v-288"},
        duration: 1
      }, '>')
      .to(flow, {
        attr: {d: "M57 174v146h337v-288h-302"},
        duration: 1
      }, '>')
      .to(flow, {
        attr: {d: "M57 174v146h337v-288h-302v12"},
        strokeDasharray: '6.38 6.38',
        duration: 1
      }, '>')
      .fromTo(flow, {
        strokeDashoffset: flow.getTotalLength() , 
      }, {
        strokeDashoffset: 0,
        ease: 'linear',
        repeat: -1,
        duration: 12
      }, '>')

    return tl
}
function mixingLinesS1(){
    const tl = new gsap.timeline()
    drawSVG(mixingFlowLinesS1Array[0], 4.1, '', 'power4.in')
    drawSVG(mixingFlowLinesS1Array[1], 4.2, '', 'power4.in')
    drawSVG(mixingFlowLinesS1Array[2], 4.3, '', 'power4.in')
    drawSVG(mixingFlowLinesS1Array[3], 4.4, '', 'power4.in')
    drawSVG(mixingFlowLinesS1Array[4], 4.3, '', 'power4.in')
    drawSVG(mixingFlowLinesS1Array[5], 4.2, '', 'power4.in')
    drawSVG(mixingFlowLinesS1Array[6], 4.1, '', 'power4.in')

    .set(mixingFlowLinesS1Array, {
        strokeDasharray: '2 2',
        // ease: 'power4.out',
        // duration: 0.1
      },)
      .fromTo(mixingFlowLinesS1Array, {
        strokeDashoffset: mixingFlowLinesS1Array[0].getTotalLength() , 
      }, {
        strokeDashoffset: 0,
        ease: 'linear',
        repeat: -1,
        duration: 10
      }, '>')
    return tl
}
function mixingLinesS2(){
    const tl = new gsap.timeline()
    drawSVG(mixingFlowLinesS2Array[0], 4.2, '', 'power4.in')
    drawSVG(mixingFlowLinesS2Array[1], 4.3, '', 'power4.in')
    drawSVG(mixingFlowLinesS2Array[2], 4.1, '', 'power4.in')
    drawSVG(mixingFlowLinesS2Array[3], 4.4, '', 'power4.in')
    drawSVG(mixingFlowLinesS2Array[4], 4.1, '', 'power4.in')
    drawSVG(mixingFlowLinesS2Array[5], 4.2, '', 'power4.in')
    drawSVG(mixingFlowLinesS2Array[6], 4.3, '', 'power4.in')

    .set(mixingFlowLinesS2Array, {
        strokeDasharray: '2 2',
        // ease: 'power4.out',
        // duration: 0.1
      },)
      .fromTo(mixingFlowLinesS2Array, {
        strokeDashoffset: mixingFlowLinesS2Array[0].getTotalLength() , 
      }, {
        strokeDashoffset: 0,
        ease: 'linear',
        repeat: -1,
        duration: 10
      }, '>')
    .fromTo(emulsionHybridSystemsT, {y: -5, opacity: 0}, {y: 0, opacity: 1, ease: 'sine', duration: 1}, '2')
    return tl
}
function agitatorFanAnimation(){
  const tl = new gsap.timeline()
  tl.fromTo(agitatorFan, {
    rotate: '0deg',
      transformOrigin: 'center center',
  },{
      repeat: -1,
      duration: 1,
      rotate: '360deg',
      ease: 'linear'
  })
  drawSVG(intankFlowLines, 1)
  .to(intankFlowLines, {
        strokeDasharray: '4 6',
        ease: 'power4.out',
        strokeOpacity: 0.5,
        duration: 0.1
    })
  .fromTo(intankFlowLines, {
        strokeDashoffset: intankFlowLines.getTotalLength() , 
    }, {
        strokeDashoffset: 0,
        ease: 'linear',
        repeat: -1,
        duration: 3
  })
  return tl
}
function changingColors(){
    const tl = new gsap.timeline()
    tl
    .addLabel('startColorChange')
    .to(linearGradient.childNodes[1], {
        attr: {offset: 0,},
        duration: 10,
    }, '+1.5')
    .to(linearGradient.childNodes[2], {
        attr: {offset: 1},
        duration: 10,
    }, '+1.5')
    .addLabel('mixedColor')
    .to([flow, ...mixingFlowLinesS1Array, ...mixingFlowLinesS2Array], {
        stroke: blendedColor,
        duration: 10,
        ease: 'linear'
    }, '+1.5')
    .to([...linearGradient.childNodes], {stopColor: blendedColor, ease: 'linear', duration: 2}, '+5')
    return tl
}

const master = new gsap.timeline()
master.add(setThings)
    // .add(makeThemMove)
    .add(entry)
    // .add(pipeCreations, "+=3")
    .add(pipeAppearance, "+=0.5")
    .add(flowStart, "+=1")
    .add(mixingLinesS1)
    .add(mixingLinesS2, '+=2')
    .add(changingColors, '+4')
    .add(agitatorFanAnimation, '+4')
    // .add(mixingLines, '+=4')
    // .add(mixerExitFlow, "+=4")
    // .add(tankFlowLines, "+=2")
    // .add(levels, '+=0')
    // .add(part2Animation, "+=24")